(function () {
    __once('controller_ready', function () {
        trigger(document, "ControllerReady");
    });
}());
